var _defs, _rect, _g;

var _excluded = ["svgRef"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgLogoVirtuale = function SvgLogoVirtuale(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_573",
    "data-name": "Group 573",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: svgRef
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-virtuals",
    x1: 0.003,
    y1: 0.052,
    x2: 0.997,
    y2: 0.948,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#1a7151"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ec7e00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fbc446"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_487",
    "data-name": "Rectangle 487",
    width: 18,
    height: 18,
    rx: 2.5,
    fill: "url(#linear-gradient-virtuals)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_572",
    "data-name": "Group 572",
    transform: "translate(3.038 3.038)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_674",
    "data-name": "Path 674",
    d: "M250.05,753.789v-4.911l-1.675-3.3-2.938-.734V744h-3.823v.849l-2.938.734-1.675,3.3v4.911l2.319,1.529v1.731h8.411v-1.731Zm-7.672-9.024h2.294v.292l-1.147,2.294-1.147-2.294ZM240.084,756.2v-6.848h-.764v5.05l-1.555-1.025v-4.316l1.434-2.821,2.592-.648.879,1.758-1.056-.529v2.767l1.529-.765v3.612a3.841,3.841,0,0,1-3.052,3.763Zm2.586-7.995-.292.146v-.292Zm-.829,8.079a4.63,4.63,0,0,0,1.683-2.01,4.63,4.63,0,0,0,1.683,2.01Zm5.124-.084h0a3.842,3.842,0,0,1-3.057-3.764v-3.612l1.529.765v-2.767l-1.057.529.879-1.759,2.592.648,1.434,2.821v4.316L247.73,754.4v-5.05h-.764Zm-2.586-8,.292-.146v.292Z",
    transform: "translate(-237 -744)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_675",
    "data-name": "Path 675",
    d: "M259.34,761.813h.764v.764h-.764Z",
    transform: "translate(-251.668 -755.696)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_676",
    "data-name": "Path 676",
    d: "M259.34,766.34h.764v.764h-.764Z",
    transform: "translate(-251.668 -758.668)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_677",
    "data-name": "Path 677",
    d: "M259.34,770.793h.764v.765h-.764Z",
    transform: "translate(-251.668 -761.592)",
    fill: "#fff"
  }))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgLogoVirtuale, _extends({
    svgRef: ref
  }, props));
});
export default "data:image/svg+xml;base64,PHN2ZyBpZD0iR3JvdXBfNTczIiBkYXRhLW5hbWU9Ikdyb3VwIDU3MyIgCiAgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiAKICB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayIgd2lkdGg9IjE4IiBoZWlnaHQ9IjE4IiB2aWV3Qm94PSIwIDAgMTggMTgiPgogIDxkZWZzPgogICAgPGxpbmVhckdyYWRpZW50IGlkPSJsaW5lYXItZ3JhZGllbnQtdmlydHVhbHMiIHgxPSIwLjAwMyIgeTE9IjAuMDUyIiB4Mj0iMC45OTciIHkyPSIwLjk0OCIgZ3JhZGllbnRVbml0cz0ib2JqZWN0Qm91bmRpbmdCb3giPgogICAgICA8c3RvcCBvZmZzZXQ9IjAiIHN0b3AtY29sb3I9IiMxYTcxNTEiLz4KICAgICAgPHN0b3Agb2Zmc2V0PSIwIiBzdG9wLWNvbG9yPSIjZWM3ZTAwIi8+CiAgICAgIDxzdG9wIG9mZnNldD0iMSIgc3RvcC1jb2xvcj0iI2ZiYzQ0NiIvPgogICAgPC9saW5lYXJHcmFkaWVudD4KICA8L2RlZnM+CiAgPHJlY3QgaWQ9IlJlY3RhbmdsZV80ODciIGRhdGEtbmFtZT0iUmVjdGFuZ2xlIDQ4NyIgd2lkdGg9IjE4IiBoZWlnaHQ9IjE4IiByeD0iMi41IiBmaWxsPSJ1cmwoI2xpbmVhci1ncmFkaWVudC12aXJ0dWFscykiLz4KICA8ZyBpZD0iR3JvdXBfNTcyIiBkYXRhLW5hbWU9Ikdyb3VwIDU3MiIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMy4wMzggMy4wMzgpIj4KICAgIDxwYXRoIGlkPSJQYXRoXzY3NCIgZGF0YS1uYW1lPSJQYXRoIDY3NCIgZD0iTTI1MC4wNSw3NTMuNzg5di00LjkxMWwtMS42NzUtMy4zLTIuOTM4LS43MzRWNzQ0aC0zLjgyM3YuODQ5bC0yLjkzOC43MzQtMS42NzUsMy4zdjQuOTExbDIuMzE5LDEuNTI5djEuNzMxaDguNDExdi0xLjczMVptLTcuNjcyLTkuMDI0aDIuMjk0di4yOTJsLTEuMTQ3LDIuMjk0LTEuMTQ3LTIuMjk0Wk0yNDAuMDg0LDc1Ni4ydi02Ljg0OGgtLjc2NHY1LjA1bC0xLjU1NS0xLjAyNXYtNC4zMTZsMS40MzQtMi44MjEsMi41OTItLjY0OC44NzksMS43NTgtMS4wNTYtLjUyOXYyLjc2N2wxLjUyOS0uNzY1djMuNjEyYTMuODQxLDMuODQxLDAsMCwxLTMuMDUyLDMuNzYzWm0yLjU4Ni03Ljk5NS0uMjkyLjE0NnYtLjI5MlptLS44MjksOC4wNzlhNC42Myw0LjYzLDAsMCwwLDEuNjgzLTIuMDEsNC42Myw0LjYzLDAsMCwwLDEuNjgzLDIuMDFabTUuMTI0LS4wODRoMGEzLjg0MiwzLjg0MiwwLDAsMS0zLjA1Ny0zLjc2NHYtMy42MTJsMS41MjkuNzY1di0yLjc2N2wtMS4wNTcuNTI5Ljg3OS0xLjc1OSwyLjU5Mi42NDgsMS40MzQsMi44MjF2NC4zMTZMMjQ3LjczLDc1NC40di01LjA1aC0uNzY0Wm0tMi41ODYtOCwuMjkyLS4xNDZ2LjI5MloiIHRyYW5zZm9ybT0idHJhbnNsYXRlKC0yMzcgLTc0NCkiIGZpbGw9IiNmZmYiLz4KICAgIDxwYXRoIGlkPSJQYXRoXzY3NSIgZGF0YS1uYW1lPSJQYXRoIDY3NSIgZD0iTTI1OS4zNCw3NjEuODEzaC43NjR2Ljc2NGgtLjc2NFoiIHRyYW5zZm9ybT0idHJhbnNsYXRlKC0yNTEuNjY4IC03NTUuNjk2KSIgZmlsbD0iI2ZmZiIvPgogICAgPHBhdGggaWQ9IlBhdGhfNjc2IiBkYXRhLW5hbWU9IlBhdGggNjc2IiBkPSJNMjU5LjM0LDc2Ni4zNGguNzY0di43NjRoLS43NjRaIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgtMjUxLjY2OCAtNzU4LjY2OCkiIGZpbGw9IiNmZmYiLz4KICAgIDxwYXRoIGlkPSJQYXRoXzY3NyIgZGF0YS1uYW1lPSJQYXRoIDY3NyIgZD0iTTI1OS4zNCw3NzAuNzkzaC43NjR2Ljc2NWgtLjc2NFoiIHRyYW5zZm9ybT0idHJhbnNsYXRlKC0yNTEuNjY4IC03NjEuNTkyKSIgZmlsbD0iI2ZmZiIvPgogIDwvZz4KPC9zdmc+Cg==";
export { ForwardRef as ReactComponent };